import React, { MouseEvent } from 'react';
import cn from 'clsx';
import { getImageSrc, Swiper, SwiperSlide } from 'common/components';
import { VariantAxisPoint, VariantAxisProduct, VariantsAxis } from 'modules/collections';
import { createElementKey } from 'utils';
import {
  activeAxisPoint,
  axisPoint,
  axisPointPreview,
  inactiveAxisPoint,
} from './axis-points-styles';

type AxisPointProps = {
  activePoint: VariantAxisProduct;
  axisPoints: VariantAxisPoint[];
  axisMeta: VariantsAxis;
  landingName: string;
  onPointClick: (e: MouseEvent, point: VariantAxisPoint, axis: string) => void;
  onPointWheelClick: (e: MouseEvent, point: VariantAxisPoint, axis: string) => () => void;
};

export const AxisPointsA: React.FC<AxisPointProps> = ({
  activePoint, axisMeta, axisPoints, landingName, onPointClick, onPointWheelClick,
}) => (
  <Swiper
    breakpoints={{
      320: { enabled: true },
      728: { enabled: false },
    }}
    slidesPerView="auto"
    watchOverflow
  >
    {axisPoints.map((point, pointIndex) => (
      <SwiperSlide
        className={cn(axisPoint, {
          [activeAxisPoint]: activePoint.axesValues?.find(({ id }) => id === axisMeta.attribute)?.axis === point.label,
          [inactiveAxisPoint]: !point.available,
        })}
        key={createElementKey('axis-point', pointIndex)}
        onClick={(e) => onPointClick(e, point, axisMeta.attribute)}
        onAuxClick={e => onPointWheelClick(e, point, axisMeta.attribute)}
      >
        <img
          alt={point.displayedName}
          className={axisPointPreview}
          height={48}
          src={getImageSrc(
            `${landingName}${point.axisMediaPhoto}`,
            {
              width: 48,
              height: 48,
              objectFit: 'fill',
            },
            true
          )}
          width={48}
        />
      </SwiperSlide>
    ))}
  </Swiper>
);
